import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import DynamicFormPage from "../../components/DynamicFormPage";
import { getPaymentMethodDetails, updatePaymentMethod } from "../../helpers/http_payment_methods_requests";

export default function OrderPaymentMethodUpdate() {

    const navigate = useNavigate();

    const { id } = useParams();

    const [formData, setFormData] = useState({ id: id });

    const formFieldList = [
        {
            title: "Atributos de Registro",
            fields: [
                {
                    name: "name",
                    label: "Nome",
                    type: "text",
                    required: true,
                },
                {
                    name: "description",
                    label: "Descrição",
                    type: "text",
                    multiline: true,
                    rows: 5,
                    fullWidth: true,
                    required: true,
                },
            ]
        },
    ];

    const handleSubmit = (data) => {
        updatePaymentMethod(data, () => navigate('/formas-de-pagamento'));
    };

    useEffect(() => {
        getPaymentMethodDetails(id, setFormData);
    }, [id]);

    return <DynamicFormPage initialData={formData} title={"Formas de Pagamento - Editar"} formFieldList={formFieldList} onCancel={() => navigate(-1)} onSubmit={handleSubmit} />;
};
